import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from '../utils/api';
import { useAuth, ROLES } from './AuthContext';

const NotificationContext = createContext();

export const useNotifications = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [loadingCount, setLoadingCount] = useState(false);

  const userRoles = Array.isArray(user?.roles) && user.roles.length > 0
    ? user.roles
    : (user?.role ? [user.role] : []);
  const isBuyerAuthenticated = Boolean(user) && userRoles.includes(ROLES.BUYER);

  const refreshNotificationCount = useCallback(async () => {
    if (!isBuyerAuthenticated) {
      setUnreadCount(0);
      return 0;
    }

    try {
      setLoadingCount(true);
      const response = await axios.get('/api/notifications/count');
      const count = Number(response.data?.unread_count || 0);
      setUnreadCount(count);
      return count;
    } catch (error) {
      setUnreadCount(0);
      return 0;
    } finally {
      setLoadingCount(false);
    }
  }, [isBuyerAuthenticated]);

  useEffect(() => {
    if (!isBuyerAuthenticated) {
      setUnreadCount(0);
      return;
    }

    refreshNotificationCount();
    const intervalId = window.setInterval(() => {
      refreshNotificationCount();
    }, 60000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [isBuyerAuthenticated, user?.id, refreshNotificationCount]);

  const value = {
    unreadCount,
    loadingCount,
    refreshNotificationCount,
    setUnreadCount,
  };

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
};
